import React, { Component }       from 'react';
import { PreregistrationCards }   from './PreregistrationCards';
import { PreregistrationOptions } from './PreregistrationOptions';
import AuthService                from 'services/auth.service';
import PreregistrationService     from 'services/preregistration.service';
import queryString                from 'query-string';

const location = AuthService.getPracticeLocation();

class Preregistration extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: this.props.params.page || 1,
      total_pages: 1,
      per: 10,
      items: [],
      stats: {
        attended: 0,
        cancelled: 0,
        skipped: 0,
        upcoming: 0
      }
    };
  }

  reloadList() {
    const parameters = queryString.stringify({
      page: this.state.page,
      per: this.state.per,
      practice_location_id: location?.id
    });

    PreregistrationService.list(parameters).then(
      (data) => {
        const meta = data.metadata;

        const stats = {
          attended: meta.attended,
          cancelled: meta.cancelled,
          skipped: meta.skipped,
          upcoming: meta.upcoming
        }

        this.setState({
          page: meta.current_page,
          total_pages: meta.total_pages,
          stats: stats,
          items: data.visits
        });
      },
      (error) => {
        console.log(error.response);

        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace('/eb/login');
        }
      }
    );
  };

  componentDidMount() {
    this.reloadList();
  }

  handlePage(previous) {
    var pageNumber = this.state.page;
    const totalPages = this.state.total_pages;

    if (previous) {
      pageNumber = pageNumber === 1 ? 1 : pageNumber - 1;
    } else {
      pageNumber = pageNumber === totalPages ? totalPages : pageNumber + 1;
    }

    this.setState({ page: pageNumber }, this.reloadList)
  }

  render() {
    return (
      <div id="main-content-target">
        <h1 className="text-danger">Pre-Registration</h1>

        <div>
          <PreregistrationOptions
            page={ this.state.page }
            total_pages={ this.state.total_pages }
            stats={ this.state.stats }
            prevPage={() => this.handlePage(true) }
            nextPage={() => this.handlePage(false) }
          />

          <PreregistrationCards items={ this.state.items } />
        </div>
      </div>
    )
  }
}

export default Preregistration;